import { defineComponent as _defineComponent } from 'vue';
import { useGetAccountQuery } from '~/types/types';
import { useVentureId } from '~/functions/accounts';
export default /*#__PURE__*/_defineComponent({
  __name: 'Association',
  setup: function setup(__props) {
    var ventureId = useVentureId();
    var _useGetAccountQuery = useGetAccountQuery(computed(function () {
        return {
          id: ventureId.value
        };
      })),
      result = _useGetAccountQuery.result,
      loading = _useGetAccountQuery.loading;
    var show = computed(function () {
      var _result$value, _result$value$getAcco;
      return result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$getAcco = _result$value.getAccount) === null || _result$value$getAcco === void 0 ? void 0 : _result$value$getAcco.esgActionsActive;
    }); // make sure feature flag is enabled(can be done in admin portal already)

    var logo = computed(function () {
      var _result$value2, _result$value2$getAcc, _result$value2$getAcc2, _result$value2$getAcc3, _result$value2$getAcc4;
      return result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : (_result$value2$getAcc = _result$value2.getAccount) === null || _result$value2$getAcc === void 0 ? void 0 : (_result$value2$getAcc2 = _result$value2$getAcc.portfolioLinks) === null || _result$value2$getAcc2 === void 0 ? void 0 : (_result$value2$getAcc3 = _result$value2$getAcc2[0]) === null || _result$value2$getAcc3 === void 0 ? void 0 : (_result$value2$getAcc4 = _result$value2$getAcc3.portfolio) === null || _result$value2$getAcc4 === void 0 ? void 0 : _result$value2$getAcc4.logo;
    });
    return {
      __sfc: true,
      ventureId: ventureId,
      result: result,
      loading: loading,
      show: show,
      logo: logo
    };
  }
});